import { Component, OnInit, OnDestroy } from '@angular/core';
import { Params, Router, ActivatedRoute } from '@angular/router';
import { PromoCodeService } from '../services/promo-code.service';
import { RouteHelperService } from '../../core/services/route-helper.service';
import { BaseEditComponent } from '../../core/common/base-component';
import { SubscriptionPlansService } from '../../subscription-plans/services/subscription-plans.service';
import 'rxjs/add/observable/zip';
import { Observable } from 'rxjs/Observable';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { Title } from '@angular/platform-browser';
/** Edits promo codes while retaining the legacy membership-codes browser URL. */
@Component({
  selector: 'ch-promo-code-edit',
  templateUrl: './promo-code-edit.component.html',
  styleUrls: ['./promo-code-edit.component.css']
})
export class PromoCodeEditComponent extends BaseEditComponent implements OnInit, OnDestroy {
  private promoCodeId: string;
  public promoCodeData: any = {};
  public codeName: string;
  public types = [{ value: 'DISCOUNT', text: 'Discount - Employment Proof Required' }, { value: 'STAFF_INCENTIVE', text: 'Staff Incentive - Employment Stage Skipped' }];
  public editMode: boolean;
  public plansList: any;
  public promoCode$: any;
  public showPlans: boolean;
  private unsubscribe$: Subject<any> = new Subject<any>();

  constructor(
    private promoCodeService: PromoCodeService,
    private subscriptionPlansService: SubscriptionPlansService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private routeHelperService: RouteHelperService,
    private titleService: Title,
  ) {
    super();
  }

  ngOnInit() {
    const plans$ = this.subscriptionPlansService.getPromoCodePlansShort();
    const promoCode$ = this.activatedRoute.queryParamMap.map((params: Params) => params.params);

    Observable.zip(plans$, promoCode$)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(([plans, promoCode]) => {
        this.plansList = plans.json();

        this.editMode = this.routeHelperService.isCurrentPageEdit();
        this.promoCodeId = promoCode.id;

        if (this.editMode) {
          this.fetchData(this.promoCodeId);
        } else {
          this.promoCodeData.type = 'DISCOUNT';
          this.titleService.setTitle(`New Promo Code | CODE Hospitality CMS`);
        }
      });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(null);
    this.unsubscribe$.unsubscribe();
    this.titleService.setTitle(`CODE Hospitality CMS`);
  }

  private fetchData(id: string) {
    this.loading = true;
    this.promoCodeService.getPromoCode(id).subscribe(
      data => {
        this.promoCodeData = data.json();
        this.codeName = this.promoCodeData.name;
        this.titleService.setTitle(`${this.promoCodeData.name} | Promo Codes | CODE Hospitality CMS`);
        this.toggleFreeSubscription(!this.promoCodeData.isFreeSubscription)

        this.loading = false;
        this.loaded = true;
      },
      error => {
        this.loading = false;
        this.loaded = true;
      }
    );
  }

  public edit(form) {
    if (!form.valid) {
      for (const i in form.controls) {
        form.controls[i].markAsTouched();
      }

      return;
    }

    const reqData: any = {};
    for (const i in this.promoCodeData) {
      reqData[i] = this.promoCodeData[i];
    }

    this.loading = true;
    const methodName = this.editMode ? 'updatePromoCode' : 'addPromoCode';
    this.promoCodeService[methodName](reqData).subscribe(
      resp => {
        this.loading = false;
        this.cancel();
      },
      error => {
        this.loading = false;
      }
    );
  }

  public toggleFreeSubscription(val: boolean) {
    if (val) {
      this.promoCodeData.overridePaidMembership = false;
      this.promoCodeData.employerName = null;
      this.showPlans = true;
    } else {
      this.showPlans = false;
    }
  }

  public toggleOverridePaidMembership(val: boolean) {
    if (!val) {
      this.promoCodeData.employerName = null;
    }
  }

  public expiryDateChange(value) {
    const d = new Date(value._d);
    this.promoCodeData.expiryDate = d;
  }

  public cancel() {
    this.router.navigateByUrl('/admin/membership-codes');
  }

  public generateRandomCode() {
    const targetSymbols = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    const targetLength = 8;
    let result = '';
    for (let i = 0; i < targetLength; i++) {
      result += targetSymbols.charAt(Math.floor(Math.random() * targetSymbols.length));
    }

    this.promoCodeData.code = result;

    return false;
  }
}



// WEBPACK FOOTER //
// /home/runner/_work/monorepo/monorepo/admin-portal-old/src/app/promo-code/promo-code-edit/promo-code-edit.component.ts